<template>
  <div class="c-main-register">
    <div class="main-register-left">
      <div class="left-title">10秒注册完成 5分钟企业自主云物联应用上线</div>
      <div class="left-desc">创建独立的品牌，可自定义系统封面/LOGO，注册直接可用</div>
      <div class="left-title">全终端可视化</div>
      <div class="left-desc">支持屏幕分享、PC、TV客户端、手机APP、微信多形式体验，跨平台自动适应</div>
      <div class="left-title">免费体验点度物联工具平台全部功能</div>
      <div class="left-desc">一键生成系统、实时远程监测、多种报警设置、个性化物联配置、个性化看板配置、灵活的权限配置等</div>
      <div class="left-img">
        <img src="../../assets/img/register/register-left-bg.png"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>
  .c-main-register {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 991;
    background: #fff;
    overflow: auto;
  }
  .main-register-left {
    position: absolute;
    top: 24%;
    right: 49%;
    margin-top: 50px;
    width: 632px;
  }
  .left-title {
    font-size: 20px;
    padding: 12px 0 3px;
    color: #333;
  }
  .left-desc {
    color: #838c9d;
  }
  .left-img{
    width: 100%;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/register/index.vue